export default "__VITE_ASSET__BT_kF9Ml__"